import React, {Component} from 'react';


import {Header}  from '../header/Header';
import {Footer} from '../footer/Footer';

import { CSSTransition } from 'react-transition-group';
import {Animated} from "react-animated-css";


import base from '../../re-base/re-base';

import "./ResultPage.css";


export class ResultPage extends Component{
    
    constructor(props){
        super(props);
        this.typeChange = this.typeChange.bind(this);
        this.rollNumChange = this.rollNumChange.bind(this);
        this.getResults = this.getResults.bind(this);
        this.state = {
            type: '',
            rollNum: '',
            grade:'',
            obtainMarks:'',
            passingMarks:'',
            percentage: '',
            totalMarks:'',
            status:'',
            heading: false,
            showTable:false
        }
    }

    typeChange(event) {
        this.setState({type: event.target.value, showTable:false,heading:false});
      }
    rollNumChange(event) {
        this.setState({rollNum: event.target.value,showTable:false,heading: false});
      }
    getResults(rollNum,type){
        this.btnClicked = true;
              
        base.fetch(type+'/'+rollNum, {
            context: this,
            then(data){
              this.setState({
                  grade: data.grade,
                  obtainMarks: data.obtainMarks,
                  passingMarks: data.passingMarks,
                  percentage: data.percentage,
                  totalMarks:data.totalMarks,
                  status:data.status
              })
              if(this.state.status){
                  this.setState({
                      showTable:true,
                      heading:true
                  });
              }
              else{
                this.setState({
                    showTable:false,
                    heading: true
                });
              }
              
        }})
      
    }
    componentWillUnmount(){
        base.reset();
    }
    showTable(){
        if(this.state.showTable){
            
            return(
                <React.Fragment>
                <CSSTransition          
                 key="1"
                 timeout={500}
                 classNames="fade">
                 <Animated animationIn="rotateIn" animationOut="fadeOut" isVisible={true}>

                <table className="table isDesktop table-responsive-sm table-dark">
             <thead>
                 <tr>
                 <th scope="col">Roll Number</th>
                 <th scope="col">Total Marks</th>
                 <th scope="col">Passing Marks</th>
                 <th scope="col">Obtained Marks</th>
                 <th scope="col">Percentage</th>
                 <th scope="col">Grade</th>
                 </tr>
             </thead>
             <tbody>
                 <tr>
                 <th scope="row">{this.state.rollNum}</th>
                 <td>{this.state.totalMarks}</td>
                 <td>{this.state.passingMarks}</td>
                 <td>{this.state.obtainMarks}</td>
                 <td>{this.state.percentage}%</td>
                 <td>{this.state.grade}</td>
                 </tr>
                 </tbody>
         </table> 
</Animated>
         </CSSTransition>
       {/* Only  Diplay in Mobile Device  */}

       <CSSTransition          
                 key="2"
                 timeout={500}
                 classNames="fade">
        <Animated animationIn="rotateIn" animationOut="fadeOut" isVisible={true}>
          <table className="table table-dark table-responsive-sm ismob">
             <tbody>
                 <tr>
                 <th scope="col">Roll Number</th>
                 <td scope="row">{this.state.rollNum}</td>
                 </tr>
                 <tr>
                 <th scope="col">Total Marks</th>
                 <td>{this.state.totalMarks}</td>

                 </tr>
                 <tr>
                 <th scope="col">Passing Marks</th>
                 <td>{this.state.passingMarks}</td>

                 </tr>
                 <tr>
                 <th scope="col">Obtained Marks</th>
                 <td>{this.state.obtainMarks}</td>

                 </tr>
                 <tr>
                 <th scope="col">Percentage</th>
                 <td>{this.state.percentage}%</td>

                 </tr>
                 <tr>
                 <th scope="col">Grade</th>
                 <td>{this.state.grade}</td>

                 </tr>
             </tbody>
                 
         </table>
         </Animated>
         </CSSTransition>

         </React.Fragment>

         )
     }
    }
    render(){
        let heading;
        if(this.state.heading){
        switch(this.state.status){
            case 'passed':
             heading = <Animated className="infinite" animationIn="flash"  animationOut="fadeOut" isVisible={true}>
                 <h4 id="passed" className="passed">
                    Congratulations you are Passed
                   </h4>
                   </Animated>
            break;
            
            case 'failed':
            heading =  <Animated animationIn="tada" animationOut="fadeOut" isVisible={true}>
                       <h4 id="failed" className="failed">
                             Sorry you are Failed
                            </h4>
                        </Animated>
            break;
            
            case undefined:
            heading = <Animated animationIn="shake" animationOut="fadeOut" isVisible={true}>
            <h1>No Result Found..</h1>
            </Animated>
            break;

            default:
            heading = ''
        }
    }
        return(
            <>
            <Header></Header>
            <br/>
            <br/>
            <div className="container-fluid">
              <h2>Annual Result 2018</h2>
                  <div className="input-group mb-3">
                        <input type="text" value={this.state.rollNum} onChange={this.rollNumChange} className="form-control" placeholder="Enter Your Roll Number" aria-label="Recipient's username" aria-describedby="button-addon2" />
                        <select value={this.state.type} onChange={this.typeChange} className="custom-select" id="inputGroupSelect04" aria-label="Example select with button addon">
                                <option selected>Choose...</option>
                                <option value="1">Humanities(Reg) Part-II A/Examination 2018</option>
                                <option value="2">Humanities(Pvt) Part-II A/Examination 2018</option>
                                <option value="3">Commerce(Reg) Part-II A/Examination 2018</option>
                                <option value="4">Commerce(Pvt) Part-II A/Examination 2018</option>
                                <option value="5">Pre-Engineering Part-II A/Examination 2018</option>
                                <option value="6">General Science Part-II A/Examination 2018</option>
                                <option value="7">Science Pre-Medical Part-II A/Examination 2018</option>
                                <option value="8">Medical Technology Part-II A/Examination 2018</option>
                                <option value="9">Home Economics Part-II A/Examination 2018</option>
                                <option value="10">Diploma in Physical Education Part-II A/Examination 2018</option>
                                <option value="11">Special Candidates Part-II A/Examination 2018</option>
                         </select>
                        <div className="input-group-append">
                            <button className="btn btn-outline-secondary" type="button" id="button-addon2" onClick={this.getResults.bind(this,this.state.rollNum,this.state.type)}>Check</button>
                        </div>
                    </div>

                    <br/>

                      <div className="text-center userResult">


                                    {heading}

                            </div>

                            {this.showTable()}

                    <br/>
                  <div className="text-center">
                    <h3>Download PDF Result 2018</h3>
                    <br/>
                    <ul className="list-group">
                        <li className="list-group-item"><a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/RESULT%20GAZETTE%20HTR-PART-II-ANNUAL-2018.pdf?alt=media&token=dd8a2f2d-989b-4a72-bedb-19798bb82023">Humanities(Reg) Part-II A/Examination 2018</a></li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/RESULT%20GAZETTE%20HTP-PART-II-ANNUAL-2018.pdf?alt=media&token=821aa491-9a08-4b01-94fd-66b9dbb42c54">Humanities(Pvt) Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/RESULT%20GAZETTE%20HTR-PART-II-ANNUAL-2018.pdf?alt=media&token=dd8a2f2d-989b-4a72-bedb-19798bb82023">Commerce(Reg) Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/Result%20Gazette%20CMP-Part-II-Annual-2018.pdf?alt=media&token=f303f485-5709-47be-953c-c090b4889173">Commerce(Pvt) Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/Final%20Result%20Gazette%20of%20SE-Part-II-2018-Annual.pdf?alt=media&token=2d7332be-351e-4d82-80e7-19ed9ea6cee1">Pre-Engineering Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/FINAL%20Result%20Gazette%20of%20SG-Part-II-2018-Annual.pdf?alt=media&token=fe577ba1-b405-4552-bd75-092150922730">General Science Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/Result%20Gazette%20of%20Pre-Medical-II-A-2018%20Final.pdf?alt=media&token=fb65f838-587d-4ab7-999a-0b86612a302b">Science Pre-Medical Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/gazzette%20med%20tech%202018.pdf?alt=media&token=1d803823-f374-4b8d-b270-cf4cac065659">Medical Technology Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/Gazzette%202018%20HE.pdf?alt=media&token=ed28b7ec-35ab-47d0-af4c-86352c5ecea1">Home Economics Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/GAZZETTE%20DPE%202018.pdf?alt=media&token=dad58886-5098-4244-bc19-8b278382e0b9">Diploma in Physical Education Part-II A/Examination 2018</a>

                        </li>
                        <li className="list-group-item">
                        <a href="https://firebasestorage.googleapis.com/v0/b/biek-edu.appspot.com/o/special%20gazzette%202018.pdf?alt=media&token=22404366-1581-4b4b-a5c3-eac5802472f0">Special Candidates Part-II A/Examination 2018</a>

                        </li>
                        </ul>
                    </div>
            </div>
            <br/>
            <br/>
            <Footer></Footer>
            </>
        )
    }
}